import { Injectable }   from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {FormBase} from "./form-base";

@Injectable({
  providedIn: 'root'
})
export class FormsControlService {

  constructor() { }
  toFormGroup(fields: FormBase<string>[] ) {
    let group: any = {};
    fields.forEach( (field, i)  => {
      group[field.key] = new FormControl(field.value || '')
      if (!field.optional) {
        group[field.key].setValidators(Validators.required);
      }
      if (field.maxLength) {
        group[field.key].setValidators(Validators.maxLength(field.maxLength));
      }
      if (field.minLength) {
        group[field.key].setValidators(Validators.minLength(field.minLength));
      }
    });
    return new FormGroup(group);
  }
}
